import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import projectUpdatesReducer from './projectUpdatesSlice';
import projectPhasesReducer from './projectPhasesSlice';
import projectTasksReducer from './projectTasksSlice';
import collaboratorsReducer from './collaboratorsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    projectUpdates: projectUpdatesReducer,
    projectPhases: projectPhasesReducer,
    projectTasks: projectTasksReducer,
    collaborators: collaboratorsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
